import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import ColorPickerListItem from '../../../../../../list-items/ColorPickerListItem/ColorPickerListItem';

const TextShadowColorListItem = (props) => {
    const { shadowSettingsColor, updateTextElement, index } = props;
    
    const onShadowColorChange = (color) => {
        var value = color.hex.replace('#', '0x');

        updateTextElement(index, { 
            shadowSettings: { color: value } 
        });
    };
    
    return (
        <ColorPickerListItem
            text='Color'
            color={shadowSettingsColor.replace('0x', '#')}
            onChange={onShadowColorChange}
            disableAlpha={true}
        />
    );
};

const mapStateToProps = (state, ownProps) => {
    const element = state.createPreview.present.videoSettings.text.textElements[ownProps.index];
    const shadowSettingsColor = element && element.shadowSettings ? element.shadowSettings.color : "0x000000";
    return { shadowSettingsColor };
}

const mapDispatchToProps = (dispatch) => {
    const updateTextElement = (index, properties) => dispatch(createActions.updateTextElement(index, properties));
    return { updateTextElement }
}

export default connect(mapStateToProps, mapDispatchToProps)(TextShadowColorListItem);
